import { useState, useEffect, forwardRef } from "react";
import { useTranslation } from "react-i18next";
import { Line } from "react-chartjs-2";
// Constants - Functions
import { graphicDataColor1, graphicDataColor2 } from "../../../../config/constants";
import { parseSecondsToMinutes, getSecondsBetweenTwoDates } from "../../../../config/functions";
import { isAppOrPlus } from "../../../../config/validateApplication";
// Components
import Graphic from "../../../graphic";
import GraphicContainer from "../../../GraphicContainer";

const SessionDurationPlot = forwardRef(({ software, recordings }, ref) => {
  const [positions, setPositions] = useState([]);
  const [prescribedSessionDurationValues, setPrescribedSessionDurationValues] = useState([]);
  const [trainedSessionDurationValues, setTrainedSessionDurationValues] = useState([]);
  const [t] = useTranslation("global");

  useEffect(() => {
    let positions = [];
    let prescribedSessionDurationValues = [];
    let trainedSessionDurationValues = [];

    recordings.forEach((recording, i) => {
      positions.push(i + 1);

      const verifyPrescriptionDuration = recording.hasOwnProperty("PRESCRIPTION_DURATION")
        ? parseSecondsToMinutes(recording.PRESCRIPTION_DURATION)
        : NaN;

      const differenceInMinutes = parseSecondsToMinutes(getSecondsBetweenTwoDates(recording.STARTING_DATE, recording.ENDING_DATE));

      prescribedSessionDurationValues.push(verifyPrescriptionDuration);
      trainedSessionDurationValues.push(
        isAppOrPlus(software)
          ? recording.hasOwnProperty("sessionDuration(seconds)")
            ? parseSecondsToMinutes(recording["sessionDuration(seconds)"])
            : NaN
          : isNaN(verifyPrescriptionDuration)
            ? NaN
            : differenceInMinutes > verifyPrescriptionDuration
              ? verifyPrescriptionDuration
              : differenceInMinutes,
      );
    });

    setPositions(positions);
    setPrescribedSessionDurationValues(prescribedSessionDurationValues);
    setTrainedSessionDurationValues(trainedSessionDurationValues);

    return () => {
      setPositions([]);
      setPrescribedSessionDurationValues([]);
      setTrainedSessionDurationValues([]);
    };
  }, [recordings, software]);

  const sessionDurationData = {
    labels: positions,
    datasets: [
      {
        label: t("prescribedMinutes"),
        data: prescribedSessionDurationValues,
        backgroundColor: [graphicDataColor1],
        borderColor: [graphicDataColor1],
      },
      {
        label: t("reports_sessionDurationGraphic_legend2"),
        data: trainedSessionDurationValues,
        backgroundColor: [graphicDataColor2],
        borderColor: [graphicDataColor2],
      },
    ],
  };

  return (
    <GraphicContainer ref={ref}>
      <Graphic
        Title={t("reports_sessionDurationGraphic_title")}
        Type={Line}
        data={sessionDurationData}
        axisY={t("reports_sessionDurationGraphic_axisY")}
        axisX={t("sessions")}
        graphicDescription={
          isAppOrPlus(software)
            ? t("graphics_sessionDurationDescription_AppAndWeb")
            : t("graphics_sessionDurationDescription_ClinicAndHome")
        }
      />
    </GraphicContainer>
  );
});

export default SessionDurationPlot;
